<template>
  <div class>
    <v-btn fab dark x-small color="green" v-on:click="addActive = true" v-if="!addActive">
      <v-icon small>mdi-plus</v-icon>
    </v-btn>
    <v-card v-if="addActive">
      <v-card-title>Ajouter un nouveau block</v-card-title>
      <v-card-text>
        <block-type v-model="addBlock.type_id" label="Type de block" />
      </v-card-text>
      <v-card-actions>
        <v-btn text>Valider</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// import libraries
import axios from "axios";
//import { required } from "vuelidate/lib/validators";
import BlockType from "../helpers/BlockType";

export default {
  components: {
    BlockType
  },
  mounted() {},
  props: {
    edit: {
      type: Object
    },
    step: {
      type: Object,
      required: true
    },
    parentId: {
      type: Number,
      default: null
    }
  },
  watch: {
    edit: function() {
      if (this.edit) {
        this.addActive = true;
        this.addBlock.type_id = this.edit.type_id;
      }
    },
    "addBlock.type_id": function() {
      this.submit();
    }
  },
  data() {
    return {
      addActive: false, // si le button est activé on affichera le "form update user info"
      addBlock: {
        type_id: null,
        parent_id: this.parentId
      },
      verificationMessage: {
        submitStatus: null,
        message: ""
      }
    };
  },
  methods: {
    async submit() {
      if (this.addBlock.type_id) {
        await axios
          .post(
            "service/" +
              this.step.services_id +
              "/step/" +
              this.step.id +
              "/block",
            this.addBlock,
            {
              headers: {
                "Content-Type": "application/json",
                "X-Requested-With": "XMLHttpRequest"
              }
            }
          )
          .then(
            function(response) {
              if (response.status === 200) {
                this.$emit("add");
                this.addActive = false;
              }
            }.bind(this)
          )
          .catch(
            function(error) {
              console.log(error);
            }.bind(this)
          );
      }
    }
  }
};
</script>

<style lang="scss" scoped>
form {
  position: relative;
  max-width: 500px;
  background-color: white;
  padding: 2rem 4rem;
  border-radius: 5px;

  .form__input {
    padding: 0.5rem;
    height: 2.4rem;
    width: 100%;
    border-radius: 20px;
  }
}

.btn {
  padding: 0.5rem 1.2rem;
  border-radius: 16px;
}
</style>